import { UserRole } from 'shared/types/userRole';

export function isSuperAdmin(role: UserRole | undefined): boolean {
  return role === UserRole.superAdmin;
}
